export const getInitials = (name: string, maxWords = 2): string =>
  name
    .split(" ")
    .slice(0, maxWords)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("");

export const capitalize = (str: string): string =>
  str.length === 0 ? str : str.charAt(0).toUpperCase() + str.slice(1);
